import React from "react";

// const TableHeader = ({ color = "primary" }) => {
const TableHeader = ({ color = "blueinvoice-table" }) => {
  return (
    <div className={`py-2 px-4 text-xs text-white bg-${color}`}>
      <div className="grid grid-cols-13 gap-4">
        <div className="col-span-1 text-center">S.No</div>
        <div className="col-span-4">Service Summary</div>
        <div className="col-span-4">Activity</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1">Rate</div>
        <div className="col-span-2 text-right">Amount</div>
      </div>
    </div>
  );
};

export default TableHeader;
